import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IPhoneType, PhoneType} from '../../shared/model/phone-type.model';
import {PhoneTypeService} from './phone-type.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'jalali-moment';
import {DpDatePickerModule} from 'ng2-jalali-date-picker';
import {Organization} from "../../shared/model/organization.model";
@Component({
  selector: 'app-phone-type-update',
  templateUrl: './phone-type-update.component.html'
})
export class PhoneTypeUpdateComponent implements OnInit {
  phoneType: IPhoneType = new PhoneType();
  isSaving: boolean;
  @Input() phoneTypeEdit;
  dateObject = moment('1395-11-22', 'jYYYY,jMM,jDD');

  constructor(protected phoneTypeService: PhoneTypeService, protected activatedRoute: ActivatedRoute, public activeModal: NgbActiveModal,) {
  }

  ngOnInit() {
    // alert(' in id===' + this.phoneTypeEdit);
    if (this.phoneTypeEdit) {

      this.phoneTypeService.find(this.phoneTypeEdit).subscribe(
        (res: HttpResponse<IPhoneType>) => {
          this.phoneType = res.body;
          // alert(this.phoneType);
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    }
    this.isSaving = false;
    // this.activatedRoute.data.subscribe(({ phoneType }) => {
    //     this.phoneType = phoneType;
    // });
  }

  previousState() {
    window.history.back();
  }


  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }

  save() {
    this.isSaving = true;
    // this.phoneType.organization = new Organization(1);

    if (this.phoneType.id !== undefined) {
      this.subscribeToSaveResponse(this.phoneTypeService.update(this.phoneType));
    } else {
      this.subscribeToSaveResponse(this.phoneTypeService.create(this.phoneType));
    }
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<IPhoneType>>) {
    result.subscribe((res: HttpResponse<IPhoneType>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError());
  }


  // private subscribeToSaveResponse(result: Observable<DocumentType>) {
  //   result.subscribe((res: DocumentType) =>
  //     this.onSaveSuccess(res), (res: Response) => {
  //     this.onSaveError();
  //   }) }
  protected onSaveSuccess() {
    this.isSaving = false;
    this.activeModal.dismiss();

    // this.previousState();
  }

  protected onSaveError() {
    this.isSaving = false;
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }


}
